import { render, staticRenderFns } from "./ProductScreenshots.vue?vue&type=template&id=14d7c0ab"
import script from "./ProductScreenshots.vue?vue&type=script&lang=js"
export * from "./ProductScreenshots.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports